<template>
  <div class="login">
    <div class="content">
        <img src="../assets/images/logo.png" class="logo" />
        <p class="title">友帮快递管理系统</p>
        <el-form :model="loginForm" status-icon :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
          <el-form-item prop="username">
            <el-input placeholder="请输入用户名" type="text" v-model="loginForm.username" autocomplete="off" prefix-icon="el-icon-user" size="medium"></el-input>
          </el-form-item>
          <el-form-item placeholder="请输入密码" prop="password">
            <el-input placeholder="请输入密码" type="password" v-model="loginForm.password" autocomplete="off" prefix-icon="el-icon-unlock" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="vcode">
            <el-input placeholder="请输入验证码" v-model.number="loginForm.vcode" prefix-icon="el-icon-message" size="medium">
              <template slot="append">
                <div v-html="vcodeInfo.image" alt="验证码" class="vcode-image" @click="getVerifyCode" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loginFun" style="width: 100%" size="medium">提交</el-button>
          </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

const passwordReg = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)(?![0-9a-zA-Z]+$)(?![0-9\\W]+$)(?![a-zA-Z\\W]+$)[0-9A-Za-z\\W]{8,18}$');
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 8) {
        callback(new Error('密码长度必须大于等于8位数'));
      } if (!passwordReg.test(value)) {
        callback(new Error('密码中必须包含字母、数字和特殊字符'));
      } else {
        callback();
      }
    };
    return {
      username: '',
      password: '',
      loginForm: {
        username: '',
        password: '',
        vcode: '',
      },
      rules: {
        username: {
          required: true, message: '请输入用户名', trigger: 'change',
        },
        password: { validator: validatePass, trigger: 'change' },
        vcode: {
          required: true, message: '请输入验证码', trigger: 'blur',
        },
      },
      vcodeInfo: {},
    };
  },
  created() {
    this.getVerifyCode();
  },
  methods: {
    ...mapActions(['getVcode', 'login', 'getDictionaries', 'getInitData']),
    async getVerifyCode() {
      const data = await this.getVcode();
      this.vcodeInfo = data;
    },
    async loginFun() {
      const res = await this.login({
        ...this.loginForm,
        vid: this.vcodeInfo.vid,
      });
      if (res && res.token) {
        window.localStorage.setItem('token', res.token);
        await this.getDictionaries();
        await this.getInitData();
        await this.$store.dispatch('getAsideMenu');
        this.$message.success('登录成功');
        this.$router.replace('/');
      }
    },
  },
};
</script>
<style lang="less">
  .vcode-image {
    width: 40px;
    svg {
      height: 28px;
      margin-left: -39px;
      margin-top: 1px;
    }
  }
  .login{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: url('../assets/images/login-bg.jpg') no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content{
    width: 320px;
    background: rgba(255,255,255,.4);
    padding: 30px;
    border-radius: 6px;
    margin-top: -200px;
    // box-shadow: 0 0 22px #bbb;
    .logo{
        display: block;
        width: 70px;
        margin: 14px auto;
    }
    .title{
      text-align: center;
      font-size: 18px;
      color: #3080fe;
      margin-bottom: 40px;
    }
    .input{
      width: 100%;
      height: 40px;
      background: #fff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-bottom: 20px;
      border: 1px solid #efefef;
      .input-left{
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #e1e1e1;
        img{
          display: block;
          width: 22px;
        }
      }
      .input-right{
        width: 260px;
        display: block;
        height: 100%;
        border: 0;
        padding-left: 10px;
        box-sizing: border-box;
        outline: none;
      }
    }
    .login-btn{
      width: 100%;
      color: #fff;
      font-size: 18px;
    }
  }
</style>

